import { useEffect, useState } from "react";
import { _DocumentFactory, _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _CostProductionOrderCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
interface Props {
    idProductionOrder: any;
    productionOrderDate: any;
}

export const CostProductionOrderCatalog = ({ idProductionOrder, productionOrderDate }: Props) => {

    const CostProductionOrderCatalog = useDataBean(_CostProductionOrderCatalog);
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {

        CostProductionOrderCatalog.instance.getCostProductionOrderCatalog(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        CostProductionOrderCatalog.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        CostProductionOrderCatalog.deleteItemVoid(CostProductionOrderCatalog.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        CostProductionOrderCatalog.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID Actividad/Tarea', property: 'IDLabour', visible: true },
        { title: 'Actividad / Tarea', property: 'LabourName', visible: true },
        { title: 'Tipode Costo', property: 'TypeName', visible: true },
        { title: 'Categoría', property: 'IndirectCostTypeName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Valor Total', property: 'TotalValue', visible: true, mask: MASK_MONEY },
        { title: 'Documento', property: 'DocumentName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDStr', visible: true },
    ]
    const verDocumentos = () => {

        if (CostProductionOrderCatalog.bean) {
            _documentos.instance.getPdfAccountantDocument(CostProductionOrderCatalog.bean.IDDocument, null, CostProductionOrderCatalog.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModalverdoc({ ...modalverdoc, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Costos de Orden de Producción">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={CostProductionOrderCatalog.setBean} listButtons={listaBotones()} ></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={CostProductionOrderCatalog.bean.Code} onChange={CostProductionOrderCatalog.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={CostProductionOrderCatalog.bean.Name} onChange={CostProductionOrderCatalog.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">

                            <DocumentViewer
                                list={docs}
                                IDDocument={CostProductionOrderCatalog.bean.IDDocument}
                                Since={CostProductionOrderCatalog.bean.DocumentDate}
                            />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {CostProductionOrderCatalog.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}